var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{attrs:{"name":_vm.name,"custom":""}},[_c('WarRoomSharePopup',{attrs:{"sharable-type":_vm.sharableType,"sharable-url":_vm.sharableUrl},on:{"on-close":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }